import React, { useEffect, useState } from 'react';
import './About.css';
import SkillContainer from './SkillContainer';

const Skill = () => {
        // Variable For Skills:
        const [expertise, setExpertise] = useState([]);
        const [comfortable, setComfortable] = useState([]);
        const [familiar, setFamiliar] = useState([]);
        const [tools, setTools] = useState([]);

        // Load All Skills from API:
        useEffect(() => {
                fetch('./skills.json')
                        .then(res => res.json())
                        .then(data => {
                                setExpertise(data[0].expertise)
                                setComfortable(data[0].comfortable)
                                setFamiliar(data[0].familiar)
                                setTools(data[0].tools)
                        })
        }, []);

        // Map All Skills:
        return (
                <div className="pb-5">
                        <h2 className="text-center text-white fw-bold text-decoration-underline">My <span className="brand-color">Skills</span></h2>
                        {/* Skill Part: */}
                        <div className="mt-5 skills"
                                data-aos="fade-right"
                                data-aos-offset="300"
                                data-aos-easing="ease-in-sine">
                                <div className="row">
                                        <div className="col-lg-3 col-md-3 col-12 d-flex align-items-center">
                                                <h4 className="brand-color fw-bolder mt-2">Expertise:</h4>
                                        </div>
                                        <div className="col-lg-9 col-md-9 col-12">
                                                {
                                                        expertise?.map(skill => <SkillContainer
                                                                skill={skill.skill}
                                                                key={skill.skill}
                                                        ></SkillContainer>)
                                                }
                                        </div>
                                </div>
                                <div className="row mt-5">
                                        <div className="col-lg-3 col-md-3 col-12 d-flex align-items-center">
                                                <h4 className="brand-color fw-bolder mt-2">Comfortable:</h4>
                                        </div>
                                        <div className="col-lg-9 col-md-9 col-12">
                                                {
                                                        comfortable?.map(skill => <SkillContainer
                                                                skill={skill.skill}
                                                                key={skill.skill}
                                                        ></SkillContainer>)
                                                }
                                        </div>
                                </div>
                                <div className="row mt-5">
                                        <div className="col-lg-3 col-md-3 col-12 d-flex align-items-center">
                                                <h4 className="brand-color fw-bolder mt-2">Familiar:</h4>
                                        </div>
                                        <div className="col-lg-9 col-md-9 col-12">
                                                {
                                                        familiar?.map(skill => <SkillContainer
                                                                skill={skill.skill}
                                                                key={skill.skill}
                                                        ></SkillContainer>)
                                                }
                                        </div>
                                </div>
                                <div className="row mt-5">
                                        <div className="col-lg-3 col-md-3 col-12 d-flex align-items-center">
                                                <h4 className="brand-color fw-bolder mt-2">Tools:</h4>
                                        </div>
                                        <div className="col-lg-9 col-md-9 col-12">
                                                {
                                                        tools?.map(skill => <SkillContainer
                                                                skill={skill.skill}
                                                                key={skill.skill}
                                                        ></SkillContainer>)
                                                }
                                        </div>
                                </div>

                        </div>
                </div>
        );
};

export default Skill;